import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLoginLogList } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Admin/LoginLog",
    getList: "getList",
    roleFilter: "roleFilter",
    houseIdFilter: "houseIdFilter",
    keywordAndDateSearch: "keywordAndDateSearch"
});

export const getLoginLogListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async (_, { rejectWithValue }) => {
        const response = await getLoginLogList();

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const roleFilterAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.roleFilter}`,
    async (data: { role: string }) => data
);

export const houseIdFilterAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.houseIdFilter}`,
    async (data: { houseIdPrefix: string }) => data
);

export const keywordAndDateSearchAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.keywordAndDateSearch}`,
    async (data: { keyword: string, loginDateStart: string, loginDateEnd: string }) => data
);